import * as React from "react";
import { useTranslation } from "react-i18next";
import "./types";
import usePluginEntities from "hooks/usePluginEntities";
export const UnlicensedText = () => {
  const { t } = useTranslation("system");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("strong", null, t("cluster_support_bundle_info.examine_content")), /* @__PURE__ */ React.createElement("br", null), t("cluster_support_bundle_info.paid_license_only"));
};
const ClusterSupportBundleInfo = () => {
  var _a;
  const { t } = useTranslation("system");
  const pluginLogger = usePluginEntities("supportBundle");
  const InfoComponent = ((_a = pluginLogger[0]) == null ? void 0 : _a.EnterpriseSupportBundleInfo) || UnlicensedText;
  return /* @__PURE__ */ React.createElement("p", { className: "description" }, t("cluster_support_bundle_info.description"), /* @__PURE__ */ React.createElement("br", null), t("cluster_support_bundle_info.enterprise_customers"), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("br", null), InfoComponent && /* @__PURE__ */ React.createElement(InfoComponent, null));
};
export default ClusterSupportBundleInfo;
